export default __webpack_public_path__ + "static/media/400.8a72ecda.woff2";